/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MarkRead } from '../models/MarkRead';
import type { NotificationList } from '../models/NotificationList';
import type { NotificationPreferences } from '../models/NotificationPreferences';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationsService {
    /**
     * List Notifications
     * The account's latest notifications for this brand, newest first, and how many are unread.
     * @param brandId
     * @returns NotificationList Successful Response
     * @throws ApiError
     */
    public static listNotifications(
        brandId: number,
    ): CancelablePromise<NotificationList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Mark Read
     * @param brandId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static markRead(
        brandId: number,
        requestBody: MarkRead,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notifications/read',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Preferences
     * Whose scheduled runs this account hears about, and for which events.
     * @returns NotificationPreferences Successful Response
     * @throws ApiError
     */
    public static getPreferences(): CancelablePromise<NotificationPreferences> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications/preferences',
        });
    }
    /**
     * Set Preferences
     * @param requestBody
     * @returns NotificationPreferences Successful Response
     * @throws ApiError
     */
    public static setPreferences(
        requestBody: NotificationPreferences,
    ): CancelablePromise<NotificationPreferences> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/notifications/preferences',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
